export class DynamicColumnName {

  public static readonly LAST_UPDATED = "Last Updated";
  public static readonly APIGEE_PROXY = "Apigee Proxy";
  public static readonly SERVICE_SCOPE = "Service Scope";
  public static readonly SERVICE_CATEGORY = "Service Category";
  public static readonly TECH_LEAD = "Tech Lead";
  public static readonly TEAM = "Team";
  public static readonly SERVICE_OWNER = "Service Owner";
  public static readonly PRODUCT_OWNER = "Product Owner";
  public static readonly PII = "PII - Fields";
  public static readonly STREAMS_CONSUMED_BY_SERVICES = "Streams Consumed By Services";
  public static readonly STREAMS_PRODUCED_BY_SERVICES = "Streams Produced By Services";
  public static readonly DMP_DOMAIN = "Domain";
  public static readonly API_OWNERSHIP = "API Ownership";
  public static readonly SERVICE_NOW_ASSIGNMENT_GROUP = "Service Now AssignmentGroup";
  public static readonly LEANIX_SERVICE = "LeanIX Service";
  public static readonly ALATION_URL = "Alation Url";
  public static readonly ASSET_CENTRIC = "Asset Centric";
  public static readonly FORCED_FILTERS_SUPPORT = "Forced Filters Support";
  public static readonly INTERNAL_ACCESS_LOGGING = "Internal Access Logging";
  public static readonly SERVICE_TO_SERVICE_COMM_SUPPORT = "Service To Service Communication Support";
  public static readonly SUPPORT_AUDIT_LOGGING = "CAT Support User Action Audit Logging";
  public static readonly LOCALIZATION_TRANSLATIONS = "Localization (Language Support)";
  public static readonly CUSTOMER_MERGE_FUNCTIONALITY = "Customer Merge Functionality";
  public static readonly ENFORCES_ENTITLEMENTS = "Enforces Entitlements";
  public static readonly ENTITLEMENTS_CAT_CORP_ENABLED = "Entitlements Cat Corp Enabled";
  public static readonly SNOWFLAKE_VIEW_NAME = "Snowflake View Name";
  public static readonly IS_IN_SNOWFLAKE = "In Snowflake";
  public static readonly CRON = "Cron";
  public static readonly ONBOARDING_DATE = "Onboarding DATE";
  public static readonly PART_OF_CAT_DIGITAL = "Part of Cat Digital";
  public static readonly SERVICE_API = "Service/API";
  public static readonly INDUSTRY = "Industry";
  public static readonly BUSINESS_UNIT = "Business Unit";
  public static readonly TECHNICAL_OWNER = "Technical Owner";
  public static readonly BUSINESS_OWNER = "Business Owner";
  public static readonly EXTERNAL_CONSUMERS = "External Consumers";
  public static readonly UNAUTHENTICATED_ACCESS = "Unauthenticated Access";
  public static readonly CONTRACT_TESTING_LIST_OF_APPLICATIONS = "Contract Testing Applications";
  public static readonly CONTRACT_TESTING_IS_ENABLED = "Contract Testing Enabled";
  public static readonly CONTRACT_TESTING_REASON = "Contract Testing Reason";
  // EIR - Entitlement Integration Rules columns
  public static readonly EIR_ASSET_CONDITION_ENFORCEMENT_COMPLIANT = "Asset Condition Enforcement Compliant";
  public static readonly EIR_ASSET_CONDITION_ENFORCEMENT_COMMENTS = "Asset Condition Enforcement Comments";
  public static readonly EIR_CLIENT_TYPE_AGNOSTIC_COMPLIANCE_COMPLIANT = "Client Type Agnostic Compliance Compliant";
  public static readonly EIR_CLIENT_TYPE_AGNOSTIC_COMPLIANCE_COMMENTS = "Client Type Agnostic Compliance Comments";
  public static readonly EIR_COMMON_LIBRARY_STANDARDIZATION_COMPLIANT = "Common Library Standardization Compliant";
  public static readonly EIR_COMMON_LIBRARY_STANDARDIZATION_COMMENTS = "Common Library Standardization Comments";
  public static readonly EIR_DYNAMIC_RULE_EXTERNALIZATION_COMPLIANT = "Dynamic Rule Externalization Compliant";
  public static readonly EIR_DYNAMIC_RULE_EXTERNALIZATION_COMMENTS = "Dynamic Rule Externalization Comments";
  public static readonly EIR_CORP_EXPERIENCE_FLAG_RESILIENCE_COMPLIANT = "Corp Experience Flag Resilience Compliant";
  public static readonly EIR_CORP_EXPERIENCE_FLAG_RESILIENCE_COMMENTS = "Corp Experience Flag Resilience Comments";
  public static readonly EIR_ENTITLEMENTS_CONTRACT_COMPLIANCE_COMPLIANT = "Entitlements Contract Compliance Compliant";
  public static readonly EIR_ENTITLEMENTS_CONTRACT_COMPLIANCE_COMMENTS = "Entitlements Contract Compliance Comments";
  public static readonly EIR_FILTER_CONDITION_ENFORCEMENT_COMPLIANT = "Filter Condition Enforcement Compliant";
  public static readonly EIR_FILTER_CONDITION_ENFORCEMENT_COMMENTS = "Filter Condition Enforcement Comments";
  public static readonly EIR_NEW_ATTRIBUTE_TOLERANCE_COMPLIANT = "New Attribute Tolerance Compliant";
  public static readonly EIR_NEW_ATTRIBUTE_TOLERANCE_COMMENTS = "New Attribute Tolerance Comments";
  public static readonly EIR_SESSION_CACHE_KEY_STANDARD_COMPLIANT = "Session Cache Key Standard Compliant";
  public static readonly EIR_SESSION_CACHE_KEY_STANDARD_COMMENTS = "Session Cache Key Standard Comments";
  public static readonly EIR_STANDARD_INTERNAL_ACCESS_CONTROL_COMPLIANT = "Standard Internal Access Control Compliant";
  public static readonly EIR_STANDARD_INTERNAL_ACCESS_CONTROL_COMMENTS = "Standard Internal Access Control Comments";
  public static readonly EIR_TOKEN_DECODING_RESTRICTION_COMPLIANT = "Token Decoding Restriction Compliant";
  public static readonly EIR_TOKEN_DECODING_RESTRICTION_COMMENTS = "Token Decoding Restriction Comments";
}
